import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/builds/messika/messika-digitale/messika/messika-nextjs/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/builds/messika/messika-digitale/messika/messika-nextjs/public/assets/styles/shipup/shipup.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/messika/messika-digitale/messika/messika-nextjs/src/presentation/components/Suivi/SuiviCommande.tsx");
